import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { hashUrl, navbatKey } from "url"

const baseUrl = hashUrl

export const restaurantsHashApi = createApi({
  reducerPath: "restaurantsHashApi",
  tagTypes: ["Restaurants"],
  // baseQuery: fetchBaseQuery({ baseUrl }),
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      headers.set("Navbat-key", navbatKey)

      return headers
    },
  }),
  endpoints: (builder) => ({
    getReastaurantByHash: builder.query({
      query: (hash) => `client/v1/bookings/${hash}`,
    }),

    updateRestaurant: builder.mutation({
      query: ({ body, bookingId, hash }) => ({
        url: `v1/master/booking/update-with-hash/${bookingId}/${hash}`,
        method: "PATCH",
        body,
      }),
    }),
  }),
})


export const { useGetReastaurantByHashQuery, useUpdateRestaurantMutation } = restaurantsHashApi;
